"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAddress = exports.getAddress = void 0;
const getAddress = (place) => {
    var _a, _b, _c;
    const address = { city: '', state: '', country: '' };
    address.lat = (_a = place.geometry) === null || _a === void 0 ? void 0 : _a.location.lat();
    address.lng = (_b = place.geometry) === null || _b === void 0 ? void 0 : _b.location.lng();
    (_c = place.address_components) === null || _c === void 0 ? void 0 : _c.forEach((component) => {
        const types = component.types;
        if (types.includes('street_number')) {
            address.streetNumber = component.long_name;
        }
        else if (types.includes('route')) {
            address.streetName = component.long_name;
        }
        else if (types.includes('neighborhood')) {
            address.neighborhood = component.long_name;
        }
        else if (types.includes('locality') || types.includes('sublocality')) {
            address.city = component.long_name;
        }
        else if (types.includes('administrative_area_level_1')) {
            address.state = component.short_name || component.long_name;
        }
        else if (types.includes('country')) {
            address.country = component.short_name || component.long_name;
        }
        else if (types.includes('postal_code')) {
            address.zip = component.long_name;
        }
    });
    return address;
};
exports.getAddress = getAddress;
const formatAddress = (address) => {
    const addressComponents = [];
    let addressStreetAndNumber;
    if (address.streetNumber) {
        addressStreetAndNumber = address.interiorNumber
            ? `${address.streetNumber}-${address.interiorNumber}`
            : address.streetNumber;
    }
    if (address.streetName) {
        addressStreetAndNumber
            ? (addressStreetAndNumber += ` ${address.streetName}`)
            : (addressStreetAndNumber = address.streetName);
    }
    addressStreetAndNumber && addressComponents.push(addressStreetAndNumber);
    address.city && addressComponents.push(address.city);
    addressComponents.push(address.state);
    addressComponents.push(address.country);
    address.zip && addressComponents.push(address.zip);
    return addressComponents.join(', ');
};
exports.formatAddress = formatAddress;
class GooglePlaces {
    constructor(googleApiKey) {
        const googlePlaceBaseURL = 'https://maps.googleapis.com/maps/api/place';
        const googlePlaceCommonParameters = `?key=${googleApiKey}`;
        this.googlePlaceAutocompleteURL = `${googlePlaceBaseURL}/autocomplete/json${googlePlaceCommonParameters}`;
        this.googlePlaceDetailsURL = `${googlePlaceBaseURL}/details/json${googlePlaceCommonParameters}`;
    }
    async queryAddressAutocomplete(input) {
        const response = await fetch(`${this.googlePlaceAutocompleteURL}&types=address&input=${input}`);
        const jsonResponse = await response.json();
        return jsonResponse.predictions
            .filter((prediction) => prediction.types.includes('street_address'))
            .map((prediction) => ({
            id: prediction.place_id,
            main: prediction.structured_formatting.main_text,
            secondary: prediction.structured_formatting.secondary_text,
        }));
    }
    async queryAddressDetails(id) {
        const response = await fetch(`${this.googlePlaceDetailsURL}&place_id=${id}`);
        const jsonResponse = await response.json();
        const result = jsonResponse.result;
        return getAddress(result);
    }
}
exports.default = GooglePlaces;
